import { render, staticRenderFns } from "./1004.vue?vue&type=template&id=3f63d7ac&scoped=true&"
import script from "./1004.vue?vue&type=script&lang=js&"
export * from "./1004.vue?vue&type=script&lang=js&"
import style0 from "./1004.vue?vue&type=style&index=0&id=3f63d7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f63d7ac",
  null
  
)

export default component.exports